import React from 'react';
import { Card, Flex, Typography, List, Alert, Divider } from 'antd';
import { table } from './struct';
import { preamble } from '../../const/dashboard/preamble';
import StaticTable from './tables';
import { distributionTableDetails } from '../../const/dashboard/workDistribution';

const { Title, Paragraph, Text } = Typography;

const Dashboard = () => {

  const createMarkup = (markUp) => {
    return { __html: markUp };
  };

  return (
    <Card {...table.wrapper}>
      <Title {...table.headline}>
        {"A) Preamble"}
      </Title>
      <br />
      <div dangerouslySetInnerHTML={createMarkup(preamble)} />
      <br />
      <br />
      <Title {...table.headline}>
        {"B) Workload Distribution"}
      </Title>
      <StaticTable />
      <br />
      <div dangerouslySetInnerHTML={createMarkup(distributionTableDetails)} />
      <br />
      <br />
      <Title {...table.headline}>
        {"C) APA Point Calculation Method"}
      </Title>
      <br />
      <div >
        Based on the workload weightage described above faculty performance will be assessed on the scale of 5.0
      </div>
      <Flex {...table.img}>
        <img
          alt='APA calculation method'
          src={require('../../assets/apa.png')}
        />
      </Flex>

      {/* New Section D: Phase 1 - Planning */}
      <Divider />
      <Title {...table.headline}>
        {"D) Phase 1: Planning"}
      </Title>
      <br />

      <Paragraph>
        <Text strong>When it opens:</Text> At the beginning of the year (APA cycle start)
        <br />
        <Text strong>Deadline:</Text> Users will have a few months to complete this phase.
      </Paragraph>

      <Title {...table.headline}>Purpose</Title>
      <Paragraph>
        This phase is for setting your annual performance plan. You are expected to estimate and declare what you plan to achieve during the upcoming year across:
        <ul>
          <li>Teaching</li>
          <li>Research</li>
          <li>Service</li>
        </ul>
      </Paragraph>

      <Title {...table.headline}>What you need to do</Title>
      <List
        bordered={false}
        split={false}
        dataSource={[
          'Fill in planned activities (e.g., courses, research papers, advising sessions)',
          'Provide expected numbers/targets',
          'Tick/select relevant responsibilities (where applicable)'
        ]}
        renderItem={item => <List.Item><Text>{item}</Text></List.Item>}
      />

      <Alert
        message="Important Notes"
        description={
          <ul style={{ marginBottom: 0, paddingLeft: 20 }}>
            <li>You can edit and update your plan until the deadline</li>
            <li>Ensure your plan is realistic and aligned with department expectations</li>
            <li>This phase acts as the baseline for later evaluation</li>
          </ul>
        }
        type="info"
        showIcon
        style={{ marginTop: 16, marginBottom: 16 }}
      />

      <Paragraph type="secondary">
        <Text italic>This is your proposed workload and goals, not final achievements.</Text>
      </Paragraph>

      {/* New Section E: Phase 2 - Evaluation */}
      <Divider />
      <Title {...table.headline}>
        {"E) Phase 2: Evaluation"}
      </Title>
      <br />

      <Paragraph>
        <Text strong>When it opens:</Text> After the third quarter of the year
        <br />
        <Text strong>Deadline:</Text> Users will have a few months to complete this phase.
      </Paragraph>

      <Title {...table.headline}>Purpose</Title>
      <Paragraph>
        This phase is for reporting your actual performance and finalizing your APA submission.
      </Paragraph>

      <Title {...table.headline}>What you need to do</Title>
      <List
        bordered={false}
        split={false}
        dataSource={[
          'Update your planned entries with actual data: modify values based on what you truly completed',
          'Add any new/unplanned activities',
          'Remove items that were not completed',
          'Enter final scores, counts, and outcomes'
        ]}
        renderItem={item => <List.Item><Text>{item}</Text></List.Item>}
      />

      <Title {...table.headline}>APA Score Calculation</Title>
      <Paragraph>
        The system will automatically calculate your APA score based on:
        <ul>
          <li>Your final (evaluated) entries</li>
          <li>Defined APA scoring rules</li>
        </ul>
      </Paragraph>

      <Alert
        message="Important Notes"
        description={
          <ul style={{ marginBottom: 0, paddingLeft: 20 }}>
            <li>Ensure all data is accurate and supported by documentation</li>
            <li>Only completed activities should be included</li>
            <li>Incomplete or incorrect entries may affect your final evaluation</li>
          </ul>
        }
        type="warning"
        showIcon
        style={{ marginTop: 16 }}
      />
    </Card>
  )
};

export default Dashboard;